import { writable } from 'svelte/store';
import Papa from 'papaparse';

function createCsvStore() {
  const { subscribe, set } = writable({
    raw: '',
    parsed: {}
  });

  return {
    subscribe,
    setCsv: (raw) => {
      const parsed = Papa.parse(raw, {
        delimiter: ',',
        header: true,
        skipEmptyLines: true
      });

      set({ raw, parsed });
    },
    reset: () => set({ raw: '', parsed: [] })
  };
}

// Create the store
export const csvStore = createCsvStore();
